// eslint-disable-next-line no-restricted-imports
import { atom, useAtom, useAtomValue } from 'jotai'
import { atomFamily } from 'jotai/utils'
import { useEffect } from 'react'
import type { RestaurantId } from '~/lib/graphql/scalars'
import type { MealPeriodTab } from '~/lib/mealPeriod/tab'
import { useReserveOverlayContext } from '~/navigation'

const defaultMealPeriod$ = atomFamily((restaurantId: RestaurantId) =>
  atom<MealPeriodTab | undefined>(undefined)
)

/**
 * 時間帯指定でコース取得したときに取得された mealPeriod をデフォルトとして設定する
 */
export function useSetDefaultMealPeriodTab(
  restaurantId: RestaurantId,
  defaultTab: MealPeriodTab | undefined
) {
  const [current, set] = useAtom(defaultMealPeriod$(restaurantId))
  useEffect(() => {
    if (current === undefined && defaultTab !== undefined) {
      set(defaultTab)
    }
  }, [current, defaultTab, set])
}

export function useMealPeriodTab(restaurantId: RestaurantId): MealPeriodTab {
  const context = useReserveOverlayContext('GUIDE')
  const defaultTab = useAtomValue(defaultMealPeriod$(restaurantId))
  // 明示的に query string で指定されていなければデフォルトの mealPeriodTab を返す
  return context?.mealPeriod ?? defaultTab ?? 'DINNER'
}
